export function getViteAppUrl(): string {
  return import.meta.env.VITE_APP_URL;
}
